// src/utils/menu/menuMapping.ts

export const menuMapping: { [key: string]: string } = {
  /* DA: 'dashboard-admin',
  DP: 'dashboard-process',
  DQ: 'dashboard-qa',
  PC: 'design-document-list',
  CS: 'design-confidence-model',
  MD: 'design-master-data',
  QA: 'review-assurance',
  MC: 'review-exception',
  DT: 'review-verification',
  MT: 'review-model-training',
  RP: 'report-system',
  CP: 'admin-access-management',
  MM: 'admin-model-management',
  ST: 'admin-client-settings',
  CT: 'admin-platform-management', */
  DAA: 'dashboard-admin',
  DPA: 'dashboard-process',
  DQA: 'dashboard-qa',
  DLA: 'design-document-list',
  CMA: 'training-confidence-model',
  MDA: 'design-master-data',
  QPA: 'review-prediction',
  QAA: 'review-assurance',
  QEA: 'review-exception',
  QVA: 'review-verification',
  MMT: 'training-model-training',
  MMR: 'MMR-yet-to-assign',
  RAR: 'report-admin',
  RSR: 'report-system',
  AMA: 'admin-access-management',
  AMP: 'admin-model-portablilty',
  CSA: 'admin-client-settings',
  PSA: 'admin-platform-management',
  MMM: 'training-model-management'
};
